import { Component } from '@angular/core';

@Component({
  selector: 'app-baseline-bed',
  templateUrl: './baseline-bed.component.html',
})
export class BaselineBedComponent {
}
